import image1 from '@/assets/images/news/detail/20200621/1.png';

export default {
  id: '20200621', //  模块 id
  title: '父与子|叮咚爸爸们，父亲节快乐！', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '在诸多文学作品中，我们都能看到关于父亲的描述。最难忘记的是朱自清散文《背影》中关于父子离别的一段：父亲为了给儿子买桔子，努力地跳下月台，穿过铁道，爬上另一边的月台。儿子望着父亲的背影，眼泪很快地流了下来。仅是“送别”这一件事，却是千千万万父亲的缩影，表达出最真实质朴的父爱。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在我们的生命中，父亲扮演着非常重要的角色，无论他是何种身份地位的人，丝毫不会影响父亲在我们心中的位置。',
      isIndent: false,
    },
    {
      type: 0,
      text: '他或许不善言辞，但是举手投足间都是对你的关心；',
      isIndent: false,
    },
    {
      type: 0,
      text: '他或许勤俭节约，但是从不会吝啬为你花钱……',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '当很多人成为父亲，谈及孩子的一切，无论过去，现在，还是未来，他们都沉浸在一种溢于言表的幸福之中。是成为父亲的角色，让同样作为儿子的他们更懂得自己的父亲，更理解“父亲”这一称呼所肩负的爱与深沉。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在2020年父亲节来临之际，我们有幸邀请了几位叮咚爸爸，请他们来谈谈当父亲之后的感受。',
      isIndent: false,
    },
    {
      type: 1,
      title: ['扫码观看'],
      isQrcode: true,
      src: [image1],
    },
    {
      type: 0,
      text:
        '父爱无言，厚重如山。没有一位爸爸堪称完美，但你却拥有最好的爸爸。愿叮咚爸爸们和叮咚人的爸爸们，父亲节快乐！',
      isIndent: false,
    },
    {
      type: 0,
      text: '特别鸣谢：全国品类运营部李婷婷和周宇霆同学提供视频指导及技术支持',
      isIndent: false,
    },
  ],
};
